// eslint-disable-next-line no-control-regex
const unicodeRegexp = /[^\u0000-\u007F]+/gim;

export const decode = (ascii: string) => unescape(ascii);

export const encode = (utf8: string) => {
  for (const [match] of utf8.matchAll(unicodeRegexp)) {
    utf8 = utf8.replace(match, escape(match));
  }

  return utf8;
};
